import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { copyToClipboard } from './copy-to-clipboard';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';

@Component({
  selector: 'app-copy-to-clipboard',
  template: `
    <zenith-button
      #buttonElement
      zn-appearance="plain"
      [attr.zn-icon-name]="copied ? 'check' : 'copy'"
      zn-tooltip-position="right"
      [attr.zn-tooltip]="'components.common.copy-to-clipboard' | translate"
      (click)="copy()" />
  `,
  standalone: true,
  imports: [ZenithComponentsModule, TranslateModule]
})
export class CopyToClipboardComponent implements AfterViewInit, OnDestroy {
  @ViewChild('buttonElement', { read: ElementRef }) buttonElement: ElementRef;
  @Input() value: string;
  copied: boolean = false;

  ngAfterViewInit(): void {
    this.buttonElement.nativeElement.addEventListener('mouseleave', () => this.onMouseLeave());
  }

  ngOnDestroy(): void {
    this.buttonElement.nativeElement.removeAllListeners('mouseleave');
  }

  copy() {
    copyToClipboard(this.value);
    this.copied = true;
  }

  private onMouseLeave() {
    this.copied = false;
  }
}
